if (!customElements.get('fg-card-slider')) {
  customElements.define('fg-card-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fg-track]');
      this.controls = this.querySelector('[data-fg-controls]');
      if (!this.track || !this.controls) return;
      this.cards = Array.from(this.track.children);
      this.previous = this.querySelector('[data-fg-previous]');
      this.next = this.querySelector('[data-fg-next]');
      this.counter = this.querySelector('[data-fg-counter]');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.update = this.update.bind(this);
      this.onPrevious = () => this.go(-1);
      this.onNext = () => this.go(1);
      this.onKey = event => {
        if (event.target !== this.track || !this.mobile.matches) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(event.key === 'ArrowRight' ? 1 : -1);
        }
      };
      this.onResize = () => {
        this.track.tabIndex = this.mobile.matches ? 0 : -1;
        this.update();
      };
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.track.addEventListener('keydown', this.onKey);
      this.previous.addEventListener('click', this.onPrevious);
      this.next.addEventListener('click', this.onNext);
      this.observer = new ResizeObserver(this.onResize);
      this.observer.observe(this.track);
      this.controls.hidden = false;
      this.onResize();
    }
    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this.update);
      this.track.removeEventListener('keydown', this.onKey);
      this.previous.removeEventListener('click', this.onPrevious);
      this.next.removeEventListener('click', this.onNext);
      this.observer?.disconnect();
    }
    index() {
      const left = this.track.getBoundingClientRect().left;
      let index = 0;
      let distance = Infinity;
      this.cards.forEach((card, i) => {
        const delta = Math.abs(card.getBoundingClientRect().left - left);
        if (delta < distance) { distance = delta; index = i; }
      });
      return index;
    }
    update() {
      const index = this.index();
      this.previous.disabled = index === 0;
      this.next.disabled = index === this.cards.length - 1;
      this.counter.textContent = (index + 1) + ' / ' + this.cards.length;
    }
    go(direction) {
      const index = Math.max(0, Math.min(this.cards.length - 1, this.index() + direction));
      const delta = this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollBy({
        left: delta,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  });
}